export class GameMode {
  constructor(name, description) {
    this.name = name;
    this.description = description;
  }

  // Abstract methods to be implemented by concrete game modes
  initialize(scene) {
    // Override in subclasses if needed
  }

  spawnPlayers(scene, players) { 
    throw new Error('Method "spawnPlayers()" must be implemented.'); 
  }
  
  checkCombat(scene) { 
    throw new Error('Method "checkCombat()" must be implemented.'); 
  }
  
  checkWinCondition(scene) { 
    throw new Error('Method "checkWinCondition()" must be implemented.'); 
  }
  
  getPlayerTarget(player, allPlayers) { 
    throw new Error('Method "getPlayerTarget()" must be implemented.'); 
  }

  getInfo() {
    return {
      name: this.name,
      description: this.description
    };
  }
}
